



<!DOCTYPE html>

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.8/css/all.css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css">
</head>







<div class="card" *ngIf="ShowCard===2">
  <div class="card-body">
<br>
    <div class="row">
      <p style="color: #6ab187;"><strong>EMPLOYEE SCREENING</strong></p>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/users.png"><a style="text-decoration: none;color:black" routerLink="/whitecollar"> <strong class="white">&nbsp; White-collar verification</strong></a></div>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/mechanic.png"><a style="text-decoration: none;color: black;"  routerLink="/bluecollar"><strong class="white"> Blue-collar verification</strong></a></div>
      <br><br>
      <div class="col-3"><img style="width: 37px;height: auto;" src="assets/online-business.png"><a style="text-decoration: none;color: black;" routerLink="/gigworker"> &nbsp;<strong class="white"> Gig Worker verification</strong></a></div>
    </div>
    <br>
    
    <div class="row">
      
      <p style="color: #6ab187;"><strong>RISK & COMPLIANCE</strong></p>
      <div class="col-3"><img style="width: 30px;height: auto;" src="assets/risktopicon.png"><a style="text-decoration: none;color: black;" routerLink="/riskmanage"><strong class="white"> Risk Management</strong></a></div>
      <div class="col-3"><img style="width: 35px;height: auto;" src="assets/onboarding.png"><a style="text-decoration: none;color: black;" routerLink="/vendor"><strong class="white" > Vendor Onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/distributortopicon.png"><a style="text-decoration: none;color: black;" routerLink="/distribute"><strong class="white"> Distributor onboarding</strong></a></div>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/duediligence.jpg"><a style="text-decoration: none;color: black;" routerLink="/duediligence"><strong class="white"> Due Diligence</strong> </a></div>
    </div>
    <br>
  
    <!--  -->
    <div class="row">
      
      <p style="color: #6ab187;"><strong> FINANCIAL INTELLIGENCE</strong></p>
      <div class="col-3"><img style="width: 40px;height: auto;" src="assets/kycsolution.png"><a style="text-decoration: none;color: black;" routerLink="/kycsolution"><strong class="white"> KYC solutions</strong> </a></div>
    </div>
    <br>
  
  </div>
</div>


<div class="card" *ngIf="ShowCard===1">
  <div class="card-body">
<br>
<p style="color: #6ab187;font-weight: 600;"><strong>PRODUCT</strong></p>

    <div class="row">
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" (click)="ShowCard=3"><strong class="white"><img style="width: 4%;height: 100%;" src="assets/docverify.png"> Document Verification</strong> </a></div>
      <div class="col"><a style="text-decoration: none;color: black;cursor: pointer;" routerLink="/service"><strong class="white"><img style="width: 5%;height: 110%;" src="assets/docsignin.png"> Document SignIn</strong> </a></div>
  
    </div>
    <br>

    <div class="row">
       </div>
    <br>
    
  </div>
</div>


<!--  -->

<div class="card" *ngIf="ShowCard===3">
  <div class="card-body">
    <br>
<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/aadhartopicon.png"><a style="text-decoration: none;color: black;" routerLink="/aadhaar"> <strong class="white"> Aadhaar verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/pantopicon.png"><a style="text-decoration: none;color: black;"  routerLink="/pan"><strong class="white"> Pan verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/gsttopicon.jpg"><a style="text-decoration: none;color: black;" routerLink="/gst"><strong class="white"> Gst verification</strong></a></div>
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/drivinglicensetop.jpg"><a style="text-decoration: none;color: black;" routerLink="/driving"><strong class="white"> Driving verification</strong></a></div>
</div><br><br>

<div class="row">
  <div class="col"><img style="width: 37px;height: 37px;" src="assets/passporttopicon.png"><a style="text-decoration: none;color: black;" routerLink="/passport"><strong class="white"> Passport verification</strong> </a></div>
  <div class="col"><img style="width: 58px;height: 44px;" src="assets/rcverify.png"><a style="text-decoration: none;color: black;" routerLink="/rcverify"><strong class="white"> RC verification</strong></a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/msmeverify.png"><a style="text-decoration: none;color: black;" routerLink="/msmeverify"><strong class="white"> MSME verification</strong> </a></div>
  <div class="col"><img style="width: 45px;height: 44px;" src="assets/verification.png"><a style="text-decoration: none;color: black;" routerLink="/dinverify"><strong class="white"> DIN verification</strong></a></div>
</div>

<br><br>
<div class="row">
  <div class="col-3"><img style="width: 35px;height: 44px;border-radius: 20px;" src="assets/cinicon.png"><a style="text-decoration: none;color: black;" routerLink="/cinverify"><strong  class="white"> CIN verification</strong></a></div>
</div>
</div>
</div>


<!--  -->
<div class="row"  data-aos="zoom-in" data-aos-delay="300" >
  <div class="col-md-6 text-center">
    <img style="width:70%;height: 90%;margin-top:10%;border-radius:40px;box-shadow: 50px 20px #76b891;" src="assets/identityverify.jpg">
</div>
    <div style="padding-top: 10%;" class="col-md-6">
        <h1>
            <span class="topic">KYC Solutions for Instant Identity Verification</span>
          </h1>
        <h5 style="padding-left: 10%;">&nbsp;&nbsp;&nbsp;Powered KYC Solution to transform your customer identification process </h5>
    </div>

    
</div>
<br><br>
<br><br>
<div class="row" data-aos="zoom-in" data-aos-delay="300"   >
    <div class="col">
        <h1 style="color: #6ab187;text-align: center;">Overcoming the Challenges with <br>Customer Onboarding</h1>
        <br>
        <p style="text-align: center;">Redundant KYC processes can pose serious risks to your Business</p>

           <br><br>
<div class="row p-2">

    <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300" class="col-md-4">
        <br>
        <img style="width: 70px;height: 65px;background-color: #eff8ff;" src="assets/customerexperience.png">
       <br><br><br>
        <h5>Broken Customer Experience</h5>
        <p style="align-items: center;">Traditional KYC processes provide a broken KYC experience owing to repetitive data submissions and manual processes</p>
    </div>
  

    <div style="background-color: #c9d9e6;" data-aos="fade-up" data-aos-delay="300" class="col-md-4">
          <br>
          <img style="width: 70px;height: 60px;" src="assets/searchkyc.png">
         <br><br><br>
          <h5>Inability to Downscale/Upscale</h5>
          <p style="align-items: center;">Organization often struggle with infrastructure constraints to provide comprehensive KYC support for multiple identity and document types/p>
      </div>
     
       
    <div style="background-color: #eff8ff;" data-aos="fade-up" data-aos-delay="300"  class="col-md-4">
        <br>
        <img style="width: 70px;height: 60px;" src="assets/growingcompliance.png">
       <br><br><br>
        <h5>Growing Compliance Risks</h5>
        <p style="align-items: center;">Staying compliant in the constantly evolving regulatory and compliance landscape poses a daily challenge for organizations</p>
    </div>


  </div>
    </div>
</div> 



<!--  -->
<br><br>
<br><br>
<div class="row" data-aos="zoom-in" data-aos-delay="300">
    <div class="col">
        <h3 style="color: #6ab187;text-align: center;">FACHECK KYC Verification </h3>
     <h3 style="text-align: center;">Seamless KYC experience for the Modern Customer</h3>
     <p style="text-align: center;">End-to-End Digital Onboarding with cutting-edge KYC solutions</p>
    </div>
</div>


<br><br><br><br>
<!--  -->
<div class="row p-2"  data-aos="fade-up" data-aos-delay="300" >
  <div class="col-md-6">
      <br>
      <img style="width: 39px;height: 39px" src="assets/fruaddetect.png">
      <span style="color: #6ab187;">Fraud Detection</span><br>
      <h3 style="text-align: start;color: #6ab187;">Can Detect fraud instantly</h3>
      <p >Our KYC solutions uses liveness detection technology to determine and validate customer’s identity in real-time. It does so by comparing user’s live image with the uploaded national identity document using biometric anti-spoof algorithms. In this way, Digital and Video KYC helps in mitigating the risks of identity thefts and financial frauds before onboarding customers in banks, NBFCs, mobile wallets, gaming, e-commerce and P2P marketplaces.</p>
  </div>

  <div class="col-md-6 text-center">
      <img style="width: 80%;height: 80%;margin-top: 20px;" src="assets/fruaddetection.png">
  </div>
  </div>


  
 <!--  -->


 <div class="row p-2" data-aos="fade-up" data-aos-delay="300">
  
     <div class="col-md-6  text-center">
         <img style="width: 80%;height: 90%;margin-left: 20px;" src="assets/customeronboardingexp.png">
     </div>
 
     <div class="col-md-6">
         <img style="width: 42px;height: 45px;" src="assets/costoptimize.png">
         <span style="color: #6ab187;height: 20%;">Cost Optimization</span>
         <h3 style="text-align: start;color: #6ab187;">Reduce Onboarding and Verification Costs</h3>
         <p >Our Digital and Video KYC solutions enable instant verification with search algorithms ensuring the fastest onboarding process for your customers, helping you in reducing account activation turnaround time  while also reducing operational costs, helping your organisation scale up at speed. Automating KYC also means you can go-to-market much faster while also reducing operational costs.</p>
     </div>
 </div>



 <!--  -->
 <div class="row p-2" data-aos="fade-up" data-aos-delay="300"  >
   <div class="col-md-6">
       <br>
       <img style="width: 39px;height: 39px" src="assets/risk&compliance.jpg">
       <span style="color: #6ab187;">Risk & Compliance</span><br>
       <h3 style="text-align: start;color: #6ab187;">Stay Compliant with Audited Reports</h3>
       <p >Get in-depth analysis and audited reports with each initiated case and track the progress of cases in bulk. Our KYC solutions are data security compliant and adhere to the global standards of data privacy, which means you can stay on top of the regulatory compliance framework.</p>
   </div>
 
   <div class="col-md-6 text-center  ">
       <img style="width: 80%;height: 80%;margin-top: 20px;" src="assets/fruaddetection.png">
   </div>
   </div>



   <!--  -->
<br><br>

<div class="row"   data-aos="zoom-in" data-aos-delay="300">
    <div class="col">
        <h3 style="color: #6ab187;text-align: center;">Types of KYC</h3>
        
        <h3 style="color: #6ab187;text-align: center;">Enabling all Online KYC Processes Compliant with SEBI, RBI and IRDAI Guidelines</h3>
     <p style="text-align: center;">Choose the best KYC process per your requirements and stay compliant with regulatory guidelines.</p>
    </div>
</div>



<!--  -->
<div class="row p-4" >
  <div class="col-md-2"></div>
  <div class="col-md-8">
    <div data-aos="fade-up" data-aos-delay="300" >
      <br>
      <img style="width: 39px;height: 39px" src="assets/videokycicon.png">
      <span style="color: #6ab187;">Video KYC (VKYC & V-CIP)</span><br>
      <p >Verify the identity of customers remotely through live video interaction. It enables banks and other financial institutions to comply with SEBI/RBI KYC regulations while offering a convenient, contactless onboarding experience.</p>
  </div>
  <div data-aos="fade-up" data-aos-delay="300" >
    <img style="width: 42px;height: 45px" src="assets/digitalkyc.png">
    <span style="color: #6ab187;height: 20%;">Digital KYC (DKYC)</span>
    <p >Reduce operational cost, accelerate onboarding processes, improve data accuracy and stay compliant with regulatory requirements by verifying identity, address and documents digitally.</p>
</div>
<div data-aos="fade-up" data-aos-delay="300" >
  <br>
  <img style="width: 39px;height: 39px" src="assets/electronickyc.png">
  <span style="color: #6ab187;">Electronic KYC (eKYC)</span><br>
  <p >Eliminate the need for physical verification and reduce verification drop-offs while significantly reducing processing time to onboard customers in real time.</p>
</div>
 <div data-aos="fade-up" data-aos-delay="300" >
        <br>
        <img style="width: 39px;height: 39px" src="assets/updown.jpg">
        <span style="color: #6ab187;">Central KYC (CKYC)</span><br>
        <p >Access and verify KYC data from the centralized CERSAI repository and remove redundancy from your kyc processes while minimizing the need for customers to provide KYC documents multiple times.</p>
    </div>
  </div>
  <div class="col-md-2"></div>
</div>




<div class="row" data-aos="zoom-in" data-aos-delay="300"  >
    <div class="col">
      <br><br><br>
        <h3 style="text-align: center;color: #6ab187;">Top Instant Verification APIs used by our Clients for KYC services</h3><br>
        <p style="text-align: center;">Instant verification and onboarding with API based KYC services</p>
    </div>
  
  </div>
  <br><br>
  
  
  
  <!--  -->
  <div  class="row p-2">
    <div class="col-md-3  mt-2 "   data-aos="fade-up" data-aos-delay="300"  >
        <div  class="card"  style="height: 180px;" >
            <div class="card-body">
                <img style="width: 34%;height:30%" src="assets/aadhaar.png">
                <br><br>
              <h5 class="card-title">Aadhaar Card Verification API</h5>
            </div>            
          </div>
    </div>
  
    <div class="col-md-3  mt-2 "   data-aos="fade-up" data-aos-delay="300"  >
      <div class="card"  style="height: 180px;" >
          <div class="card-body">
              <img style="width: 34%;height:30%" src="assets/panchecks.png">
              <br><br>
            <h5 class="card-title">PAN Card Verification API</h5>
          </div>            
        </div>
  </div>
  
  <div class="col-md-3  mt-2 "   data-aos="fade-up" data-aos-delay="300"  >
    <div class="card"  style="height: 180px;" >
        <div  class="card-body">
  
            <img style="width: 30%;height:30%" src="assets/voterid.jpg">
            <br><br>
          <h5 class="card-title">Voter Card Verification API</h5>
        </div>            
      </div>
  </div>
  
  <div class="col-md-3  mt-2 "   data-aos="fade-up" data-aos-delay="300"  >
  <div class="card"  style="height: 180px;" >
      <div class="card-body">
          <img style="width: 34%;height:30%"  src="assets/passportverification.png">
          <br><br>
        <h5 class="card-title">Passport Verification API</h5>
  
      </div>            
    </div>
  </div>
  <div class="col-md-3  mt-2 "   data-aos="fade-up" data-aos-delay="300"  >
    <div  class="card"  style="height: 180px;" >
        <div class="card-body">
            <img style="width: 34%;height:30%" src="assets/driving.png">
            <br><br>
          <h5 class="card-title">Driving license verification API</h5>
        </div>            
      </div>
</div>

<div class="col-md-3  mt-2 "   data-aos="fade-up" data-aos-delay="300"  >
  <div class="card"  style="height: 180px;" >
      <div class="card-body">
          <img style="width: 34%;height:30%" src="assets/bankacc.png">
          <br><br>
        <h5 class="card-title">Bank account Verification API</h5>
      </div>            
    </div>
</div>

<div class="col-md-3  mt-2 "   data-aos="fade-up" data-aos-delay="300"  >
<div class="card"  style="height: 180px;" >
    <div  class="card-body">

        <img style="width: 30%;height:30%" src="assets/rcver.jpg">
        <br><br>
      <h5 class="card-title">RC Verification API</h5>
    </div>            
  </div>
</div>

<div class="col-md-3  mt-2 "   data-aos="fade-up" data-aos-delay="300"  >
<div class="card"  style="height: 180px;" >
  <div class="card-body">
      <img style="width: 34%;height:30%"  src="assets/faceverify.jpg">
      <br><br>
    <h5 class="card-title">Face Verification API</h5>

  </div>            
</div>
</div>
  </div>
  <br><br>



    
  <!--  -->

    
  

 




   <!-- advantages -->
  
 <div class="row"  data-aos="zoom-in" data-aos-delay="300"  >
    <div class="col">
            <h2 style="text-align: center;font-size: 550;color: #6ab187;">Powering KYC Technologies for 10+ Industries</h2>
            <p style="text-align: center;">KYC Solution for All Industries</p>
    </div>
    </div>
    <br><br><br>
  
  
  
      <div  class="row p-2">
    
          <div style="background-color: #eff8ff;"  class="col-md-3" data-aos="fade-up" data-aos-delay="300"   >
              <br>
              <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/bankaccount.png">
             <br><br><br>
              <h5>Banking and Financial Services  </h5>
              <p style="align-items: center;">Onboard and Verify customers, borrowers and users </p>
          </div>
        
      
           
           
      
          <div style="background-color: #eff8ff;"  class="col-md-3" data-aos="fade-up" data-aos-delay="300"   >
              <br>
              <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/ecommerce.png">
             <br><br><br>
              <h5>Internet / E-Commerce </h5>
              <p style="align-items: center;">Verify the users and sellers to prevent frauds</p>
          </div>

          
          <div style="background-color: #eff8ff;"  class="col-md-3" data-aos="fade-up" data-aos-delay="300"   >
            <br>
            <img style="width: 60px;height: 65px;background-color: #eff8ff;" src="assets/insurance.png">
           <br><br><br>
            <h5>Insurance</h5>
            <p style="align-items: center;">Authenticate the policy holders to ensure credibility</p>
        </div>

         
          <div  style="background-color: #eff8ff;" class="col-md-3" data-aos="fade-up" data-aos-delay="300"   >
         
            <br>
            <img style="width: 60px;height: 60px;" src="assets/cell-tower.png">
           <br><br><br>
            <h5>Telecommunication </h5>
            <p style="align-items: center;">Fastrack onboarding and verification of new users<p>
        </div>
        </div>





  <div class="row" data-aos="zoom-in" data-aos-delay="300"   >
    <div class="col">
      <br><br><br>
      <!-- Footer -->
      <footer class="text-center text-lg-start text-white" style="background-color: #1c2331">
        <!-- Section: Social media -->
        <section class="d-flex justify-content-between p-4" style="background-color: #6ab187">
          <!-- Left -->
          <div class="me-5">
            <span>Get connected with us on social networks:</span>
          </div>
          <!-- Left -->
  
          <!-- Right -->
          <div>
  
            <a href="" class="text-white me-5">
              <i class="fab fa-instagram"></i>
            </a>
  
  
          </div>
          <!-- Right -->
        </section>
        <!-- Section: Social media -->
  
  
        <section data-aos="zoom-in" data-aos-delay="300" class="p-4">
          <div class="text-center text-md-start mt-5">
  
            <div class="row">
  
              <div class="col-md-4 ">
                <!-- Content -->
  
                <h6 style="margin-right: 74%;font-size:16px" class="text-uppercase fw-bold"><img
                    style="width: 27px;height: auto;border-radius: 40%;" src="assets/handlogo.png"> FACheck</h6>
  
                <p style="text-align: justify;
    text-justify: inter-word">
                  Facheck is a very useful product in the Finance,Banking, and growing Industries in India. It checks &
                  authenticates the Person / Company document and reveals the result with the validity and truth of the
                  document. So, with the help of the Facheck - verification you can process the proper document and
                  avoid fraudulent disclosures. It help your organization to proceed further with Fact-Check of your
                  clients.
                </p>
              </div>
  
  
              <div class="col-md-2">
                <!-- Links -->
                <h6 class="text-uppercase fw-bold" >Solutions</h6>
  
                <p>
                  <a href="bluecollar"  class="text-white">Blue-collar
                    verify</a>
                </p>
                <p>
                  <a href="distribute"  class="text-white">Distributor
                    Onboard</a>
                </p>
                <p>
  
                  <a href="duediligence"  class="text-white">Due
                    Diligence</a>
                </p>
                <p>
  
                  <a href="gigworker"  class="text-white">Gig Worker
                    Verify</a>
  
                </p>
                <p>
  
                  <a href="kycsolution"  class="text-white">KYC
                    Solutions</a>
                </p>
                <p>
                  <a href="riskmanage"  class="text-white">Risk Manage</a>
                </p>
                <p>
  
                  <a href="vendor"  class="text-white">Vendor Onboard</a>
                </p>
                <p>
  
                  <a href="whitecollar"  class="text-white">White-collar
                    verify</a>
                </p>
              </div>
  
  
              <div  class="col-md-2 text-align">
  
                <h6 class="text-uppercase fw-bold" >Products</h6>
  
                <p>
                  <a href="aadhaar"  class="text-white">Aadhaar verify</a>
                </p>
                <p>
                  <a href="cinverify"  class="text-white">CIN verify</a>
                </p>
                <p>
                  <a href="dinverify"  class="text-white">DIN verify</a>
                </p>
                <p>
                  <a href="driving"  class="text-white">Driving License</a>
                </p>
                <p>
                  <a href="gst"  class="text-white">GST verify</a>
                </p>
                <p>
                  <a  href="msmeverify" class="text-white">MSME verify</a>
                </p>
                <p>
                  <a href="pan"  class="text-white">PAN verify</a>
                </p>
                <p>
                  <a href="passport"  class="text-white">Passport verify</a>
                </p>
                <p>
                  <a href="rcverify"  class="text-white">RC verify</a>
                </p>
  
                <br><br><br>
              </div>
  
  
  
  
              <div  class="col-md-4 text-center">
  
                <h6  class="text-uppercase fw-bold">Quick links</h6>
  
  
                <a  href="privacypolicy">Privacy Policy</a>
                <br><br>
                <a  href="termscondition">Terms & Condition</a>
                <br><br>
  
                <a  href="refundpolicy">Refund Policy</a>
                <br><br>
                <!-- Links -->
                <h6 class="text-uppercase fw-bold">Contact</h6>
  
  
                <p >support@facheck.in &nbsp;<i
                    class="fas fa-envelope mr"></i> </p>
  
                <p  class=" text-center ">Registered Head Office <i class="fas fa-home"></i>
                  <br>New 9, Old # 11, Ground Floor,
                  Palayakaran Street, Kalaimagal Nagar, Ekkaduthangal, Chennai
                </p>
  
              </div>
  
  
            
  
  
            </div>
            <!-- Grid row -->
  
  
          </div>
        </section>
        <br>
        <div class="text-center p-3" style="background-color: rgba(0, 0, 0, 0.2)">
          Copyright© 2023. Powered by
          <a class="text-white" href="#">facheck.com
            | All Rights Reserved </a>
        </div>
  
      </footer>
      <!-- Footer -->
  
    </div>
  </div>
  
          